import React, { Component } from 'react';
import { Container, Header, Button, Icon, Divider, Image, Grid, List, Dropdown, Transition, Label, Popup, Segment, Table, Accordion } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../App.js';
import Collapsible from 'react-collapsible';
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
// import {appendixInformation} from './constants/appendixConstants.js'
import Citation from './Citation.js'

import * as Scroll from 'react-scroll';
import ReactGA from "react-ga4";
ReactGA.initialize("G-BCN5V0JQN1")
var scroll    = Scroll.animateScroll;


let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}


class AppendixMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
      history: props.location.state === undefined ? [] : props.location.state.history,
      from: props.location.state === undefined ? '' : props.location.state.from,
      Yposition:0,
		}
      // if (decodeURI(props.match.params.word) != 'appendix') {
      //   this.props.history.push('/appendix')
      // }
	    scroll.scrollTo(0);
	}

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll)
  }

  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop

    // const height =
      // document.documentElement.scrollHeight -
      // document.documentElement.clientHeight

    // const scrolled = winScroll / height

    // console.log(winScroll, height)

    this.setState({
      Yposition: winScroll,
    })
  }


  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)
    this.setState({ 
			from: nextProps.location.pathname,
			// fullDefinition: nextProps.fullDefinition,
		})
	}
  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.currentType !== this.state.currentType && this.state.currentType === 'adv') {
  //       this.setState({currentCase:'base'})
  //   }
  //   if (prevState.currentType !== this.state.currentType && this.state.currentType === 'pro') {
  //       this.setState({currentCase:'abs',currentNumber:'sg'})
  //   }

  // }


  // repeatAudio(audio, event, data) {
  //   if (!this.state.playingAudio) {

  //     let sound = new Audio(API_URL + "/inupiaqaudiolibrary/" +  audio.replaceAll('/','~'));
  //     this.setState({playingAudio: true});

  //     sound.play()

  //     sound.onended=()=>{
  //       this.setState({playingAudio: false});
  //     }
  //   }
  // }
 
  // handleTitleChange = (e, { value }) => {
  // 	this.setState({ demTableType:value })
  // }

  // handleTableTypeOptions = (e, { value }) => {
  //   this.setState({ currentType:value })
  // }

  // handleTableAdvCaseOptions = (e, { value }) => {
  //   this.setState({ currentCase:value })
  // }

  // handleTableProCaseOptions = (e, { value }) => {
  //   this.setState({ currentCase:value })
  // }

  // handleTableProNumberOptions = (e, { value }) => {
  //   this.setState({ currentNumber:value })
  // }



  // getCorrectForm = (word, e, value) => {
  //   // console.log(word)
  //   // console.log(this.state.demTableType)
  //   // console.log(word)
  //   // console.log(this.props.demonstrativedata[word])
  //   //this.props.demonstrativedata[this.state.currentRoot]['pro'][e]["examples"]
  //   //this.props.demonstrativedata[this.state.currentRoot]['adv'][p]['word']['text']
  //   //this.props.demonstrativedata[this.state.currentRoot]['pro'][l][[i]]['text']
  //   if (word.length !== 0) {
  //     if (this.state.currentType == 'roots') {
  //       return word.replaceAll('⎤','-').replaceAll('⎡°','').replaceAll(',',', ').toLowerCase()
  //     } else if (this.state.currentType == 'adv' && this.state.currentCase.length !== 0 && this.state.currentCase !== 'sim' && this.state.currentCase in this.props.demonstrativedata[word]['adv']) {
  //       return this.props.demonstrativedata[word]['adv'][this.state.currentCase]['word']['text']
  //     } else if (this.state.currentType == 'pro' && this.state.currentCase.length !== 0 && this.state.currentNumber.length !== 0 && this.state.currentCase in this.props.demonstrativedata[word]['pro']) {
  //       return this.props.demonstrativedata[word]['pro'][this.state.currentCase][[this.state.currentNumber]]['text']
  //     } else {
  //       return word      
  //     }      
  //   }

  // }

    processStyledText = (sentence) => {
      // sentence = sentence.replaceAll(">","")


      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("«","").replaceAll("»","")
      let matches = sentence.match(/⎡.*?⎤/g)
      let matches1 = sentence.match(/{.*?}/g)
      let matches2 = sentence.match(/_.*?_/g)
      // console.log(matches2)
      if (matches !== null || matches1 !== null || matches2 !== null) {
        if (matches !== null) {
          matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
        }
        if (matches1 !== null) {
          matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
        }
        if (matches2 !== null) {
          matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
        }
        return <span dangerouslySetInnerHTML={{__html: sentence}} />    
      } else {
        return <span>{sentence}</span>
      }


      // let matches = sentence.match(/\⎡.*?\⎤/g)
      // if (matches !== null) {
      //   matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))   
      //   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
      // } else {
      //   return <span>{sentence}</span>
      // }
    }


    processStyledTextLink = (sentence) => {
      sentence = sentence.replaceAll(">","")


      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("↞","").replaceAll("&","").replaceAll("↠","")
      let matches = sentence.match(/⎡.*?⎤/g)
      let matches1 = sentence.match(/{.*?}/g)
      let matches2 = sentence.match(/_.*?_/g)
      // console.log(matches2)
      if (matches !== null || matches1 !== null || matches2 !== null) {
        if (matches !== null) {
          matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
        }
        if (matches1 !== null) {
          matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
        }
        if (matches2 !== null) {
          matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
        }
        return <span style={{whiteSpace:'nowrap'}} dangerouslySetInnerHTML={{__html: sentence}} />    
      } else {
        return <span style={{whiteSpace:'nowrap'}}>{sentence}</span>
      }


      // let matches = sentence.match(/\⎡.*?\⎤/g)
      // if (matches !== null) {
      //   matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))   
      //   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
      // } else {
      //   return <span>{sentence}</span>
      // }
    }


  render() {
    // console.log(this.state)
    // let tableCase = {}
    // let tableCaseTat = {}

    // if (this.state.demTableType == 'adverbs') {
    // 	tableCase = tableCaseAdverbs
    // 	tableCaseTat = tableCaseTatAdverbs
    // 	tableTitle = 'Demonstrative adverbs'
    // } else if (this.state.demTableType == 'pronouns') {
    // 	tableCase = tableCasePronouns
    // 	tableCaseTat = tableCaseTatPronouns
    // 	tableTitle = 'Demonstrative abs. pronouns'
    // } else {
    // 	tableCase = tableCaseRoots
    // 	tableCaseTat = tableCaseTatRoots
    // 	tableTitle = 'Demonstrative roots'
    // }

    // const { activeIndex2 } = this.state;
		// console.log(this.props.location)
		// console.log(this.props)
    // let clickText = 'a root'
    // if (this.state.currentType == 'adv') {
    //   clickText = 'an adverb'
    // } else if (this.state.currentType == 'pro') {
    //   clickText = 'a pronoun'
    // }
    let showKeys = false
	
		return (
			<div style={{fontFamily:customFontFam}}>
          <Grid textAlign='center'>
          <Grid.Row  style={{height:40,padding:10}}>
          <Grid.Column style={{ maxWidth: 800, padding: 15 }} textAlign='left'>

			<div style={{display:'flex'}}>
	      <div style={{flex:1,justifyContent:'flex-start'}}>
          <Link to={{pathname: "/"}} >
            <Button basic style={{paddingLeft:'10px',paddingRight:'15px',marginBottom:'13px',marginTop:'10px'}} icon='left chevron' content='Back to Homepage' />
          </Link>			
	      </div>


			</div>


					<div style={{border:'1px solid #E3E3E3',marginTop:'10px',marginBottom:'15px'}}>

					<div style={{marginBottom:15}} className='hierarchymain'>
					<span className='span1'>Aperyarat Calricaraam Tungiinun</span>
					<span className='span2'>Terminology Related to Health & Well-Being</span>
					</div>


          <div style={{fontSize:'16px'}}>
          <List>


                {['1','2','3','4','5','6','7','8','9','10'].map((k,kindex)=>
                
                <List.Item style={{padding:0,textAlign:'center'}}>
                  <div>
                      <div style={{fontSize:'17px',lineHeight:'24px',}}>
                        <div style={{padding:10, marginTop:(kindex === 0 ? 0 : 15),fontStyle:'italic'}}>
                          <span style={{color:'#989898'}}>{'Appendix '+k+': '}</span>
                        </div>
                        <Link to={{pathname: "/appendix/"+k}}>
                          <span style={{cursor:'pointer',color:'#306190',paddingRight:'10px',paddingLeft:'10px'}}>
                            <span style={{fontWeight:'bold',paddingBottom:'1px',borderBottom:'1px solid #858585',}}>{this.props.resourceIDs[k][0][0]}</span>
                            <span>
                            </span>
                            <span style={{fontStyle:'italic',paddingBottom:'1px',borderBottom:'1px solid #858585',}}>{' - '+this.props.resourceIDs[k][1][0]}</span>
                          </span>
                        </Link>
                      </div>
                </div>
              </List.Item>

                  )}

                <List.Item style={{padding:0,paddingBottom:20,textAlign:'center'}}>
                  <div>
                      <div style={{fontSize:'17px',lineHeight:'24px',}}>
                        <div style={{padding:10, marginTop:15,fontStyle:'italic'}}>
                          <span style={{color:'#989898'}}>{'Appendix 11:'}</span>
                        </div>
                        <Link to={{pathname: "/printouts"}}>
                          <span style={{cursor:'pointer',color:'#306190',paddingRight:'10px',paddingLeft:'10px'}}>
                            <span style={{fontWeight:'bold',paddingBottom:'1px',borderBottom:'1px solid #858585',}}>{'Printable Reports'}</span>
                          </span>
                        </Link>
                      </div>
                </div>
              </List.Item> 

          </List>
					


					</div>
          </div>
          <Citation /> 

				</Grid.Column>
				</Grid.Row>
				</Grid>
			</div>
		);
	}
}
export default AppendixMenu;